module.exports = __webpack_public_path__ + "img/game--fifa-22--esrb.7bf311c7.png";